import React, {useState} from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {onDesktop, p} from "@pg-design/helpers-css";
import {ArrowIcon} from "@pg-design/icons-module";
import {useComparisonTable} from "@pg-rp/comparison-table";

import {OneColumnGridFullWidth} from "../../atoms/OneColumnGrid";
import {useMyOffersFavourites} from "../../my_offers/hooks/use_my_offers_favourites";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../property/utils/is_property_archived";
import {comparisonToolTableRows} from "../constants/comparison_tool_table_rows";
import {IAnalyticEvents} from "../interfaces/IAnalyticEvents";
import {AskForAllModal} from "./AskForAllModal/AskForAllModal";
import {ComparisonToolTable} from "./ComparisonToolTable/ComparisonToolTable";
import {ComparisonToolViewHeader} from "./ComparisonToolViewHeader";

interface IProps {
    analyticEvents?: IAnalyticEvents;
    onBackClick?: () => void;
}

export const ComparisonTool = (props: IProps) => {
    const {favouriteProperties} = useMyOffersFavourites();
    const [askForAllModalOpened, setAskForAllModalOpened] = useState(false);
    const {tableProps, tableNavigation} = useComparisonTable<IPropertyDetail>({
        rows: comparisonToolTableRows,
        onScrollLeft: () => {
            props.analyticEvents?.onLeftArrowClick?.();
        },
        onScrollRight: () => {
            props.analyticEvents?.onRightArrowClick?.();
        }
    });

    const hasActiveProperties = favouriteProperties.some((property) => !isPropertyArchived(property));

    return (
        <>
            <OneColumnGridFullWidth>
                {props.onBackClick && (
                    <div css={backWrapStyle}>
                        <Button variant="none_secondary" size="x-small" iconLeft={ArrowIcon} css={backStyle} onClick={props.onBackClick}>
                            Powrót do listy ofert
                        </Button>
                    </div>
                )}

                <ComparisonToolViewHeader
                    total={favouriteProperties.length}
                    hasActiveProperties={hasActiveProperties}
                    onLeftArrowClick={() => {
                        tableNavigation.scrollLeft();
                    }}
                    onRightArrowClick={() => {
                        tableNavigation.scrollRight();
                    }}
                />
            </OneColumnGridFullWidth>
            <OneColumnGridFullWidth noGutters>
                {favouriteProperties.length > 0 && (
                    <>
                        <ComparisonToolTable {...tableProps} />
                        {hasActiveProperties && (
                            <div css={linkButtonWrap}>
                                <Button
                                    variant="filled_primary"
                                    onClick={() => {
                                        setAskForAllModalOpened(true);
                                    }}
                                >
                                    Zapytaj o wszystkie
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </OneColumnGridFullWidth>
            {askForAllModalOpened && (
                <AskForAllModal
                    isOpened={askForAllModalOpened}
                    closeModal={() => {
                        setAskForAllModalOpened(false);
                    }}
                />
            )}
        </>
    );
};

const backWrapStyle = css`
    display: flex;
    justify-content: flex-start;
    ${p(2, 0, 2, 0)}

    ${onDesktop(css`
        ${p(3, 0, 1.5, 0)}
    `)}
`;

const backStyle = (theme: Theme) => css`
    //TODO: Consider this as a new button variant
    color: ${theme.colors.gray["700"]};
    padding: 0;
    height: auto;

    @media print {
        display: none;
    }

    svg {
        margin: 0 1.4rem 0 1rem;
        fill: ${theme.colors.gray["700"]};
    }
`;

const linkButtonWrap = css`
    ${p(2)}
    display: flex;
    align-items: center;
    justify-content: center;
`;
import React, {useState} from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {onDesktop, p} from "@pg-design/helpers-css";
import {ArrowIcon} from "@pg-design/icons-module";
import {useComparisonTable} from "@pg-rp/comparison-table";

import {OneColumnGridFullWidth} from "../../atoms/OneColumnGrid";
import {useMyOffersFavourites} from "../../my_offers/hooks/use_my_offers_favourites";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../property/utils/is_property_archived";
import {comparisonToolTableRows} from "../constants/comparison_tool_table_rows";
import {IAnalyticEvents} from "../interfaces/IAnalyticEvents";
import {AskForAllModal} from "./AskForAllModal/AskForAllModal";
import {ComparisonToolTable} from "./ComparisonToolTable/ComparisonToolTable";
import {ComparisonToolViewHeader} from "./ComparisonToolViewHeader";

interface IProps {
    analyticEvents?: IAnalyticEvents;
    onBackClick?: () => void;
}

export const ComparisonTool = (props: IProps) => {
    const {favouriteProperties} = useMyOffersFavourites();
    const [askForAllModalOpened, setAskForAllModalOpened] = useState(false);
    const {tableProps, tableNavigation} = useComparisonTable<IPropertyDetail>({
        rows: comparisonToolTableRows,
        onScrollLeft: () => {
            props.analyticEvents?.onLeftArrowClick?.();
        },
        onScrollRight: () => {
            props.analyticEvents?.onRightArrowClick?.();
        }
    });

    const hasActiveProperties = favouriteProperties.some((property) => !isPropertyArchived(property));

    return (
        <>
            <OneColumnGridFullWidth>
                {props.onBackClick && (
                    <div css={backWrapStyle}>
                        <Button variant="none_secondary" size="x-small" iconLeft={ArrowIcon} css={backStyle} onClick={props.onBackClick}>
                            Powrót do listy ofert
                        </Button>
                    </div>
                )}

                <ComparisonToolViewHeader
                    total={favouriteProperties.length}
                    hasActiveProperties={hasActiveProperties}
                    onLeftArrowClick={() => {
                        tableNavigation.scrollLeft();
                    }}
                    onRightArrowClick={() => {
                        tableNavigation.scrollRight();
                    }}
                />
            </OneColumnGridFullWidth>
            <OneColumnGridFullWidth noGutters>
                {favouriteProperties.length > 0 && (
                    <>
                        <ComparisonToolTable {...tableProps} />
                        {hasActiveProperties && (
                            <div css={linkButtonWrap}>
                                <Button
                                    variant="filled_primary"
                                    onClick={() => {
                                        setAskForAllModalOpened(true);
                                    }}
                                >
                                    Zapytaj o wszystkie
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </OneColumnGridFullWidth>
            {askForAllModalOpened && (
                <AskForAllModal
                    isOpened={askForAllModalOpened}
                    closeModal={() => {
                        setAskForAllModalOpened(false);
                    }}
                />
            )}
        </>
    );
};

const backWrapStyle = css`
    display: flex;
    justify-content: flex-start;
    ${p(2, 0, 2, 0)}

    ${onDesktop(css`
        ${p(3, 0, 1.5, 0)}
    `)}
`;

const backStyle = (theme: Theme) => css`
    //TODO: Consider this as a new button variant
    color: ${theme.colors.gray["700"]};
    padding: 0;
    height: auto;

    @media print {
        display: none;
    }

    svg {
        margin: 0 1.4rem 0 1rem;
        fill: ${theme.colors.gray["700"]};
    }
`;

const linkButtonWrap = css`
    ${p(2)}
    display: flex;
    align-items: center;
    justify-content: center;
`;
